module.exports = __webpack_public_path__ + "static/malware_nowhere_icon-c8aeaf6d4deded7a51526d768fdc5465.svg";